import Button from '@atlaskit/button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import React, { useState } from 'react';
import { atlassianStandsWithUkraineMessage } from './AtlassianStandsWithUkraineModal.constants';
const AtlassianStandsWithUkraineModal = () => {
  const atlassianStandsWithUkraine = !localStorage.getItem('atlassianStandsWithUkraine');
  const [isOpen, setIsOpen] = useState(atlassianStandsWithUkraine);
  const onClose = () => {
    localStorage.setItem('atlassianStandsWithUkraine', 'true');
    setIsOpen(false);
  };
  return /*#__PURE__*/React.createElement(ModalTransition, null, isOpen && /*#__PURE__*/React.createElement(Modal, {
    width: "small"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, null, atlassianStandsWithUkraineMessage.header)), /*#__PURE__*/React.createElement(ModalBody, null, atlassianStandsWithUkraineMessage.body), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: onClose,
    autoFocus: true
  }, "Okay"))));
};
export default AtlassianStandsWithUkraineModal;